import React from "react";

const TotalSalesNormalization = ({ row }) => {
  return <div>{row?.totalSales?.toLocaleString()}</div>;
};

export default TotalSalesNormalization;
